module.exports = __webpack_public_path__ + "img/save.61e5d17e.svg";